<template>
  <withTopNav :leftText="configInfo.activityConfigName || 'Bônus'" fixed>
    <div class="pb-[64px]">
      <img :src="topBg" class="w-full h-[276px]" alt="" />
      <div class="px-[16px]">
        <div class="text-white text-[18px]">
          R$
          <span class="text-[#FFDF12] text-[24px] mx-1">
            {{ formatter().format(configInfo.perTimeShowMaxAmount || 0) }}
          </span>
          {{ t("Activities.Redpackage.PerTimeShowMaxAmount") }}
        </div>
        <div class="text-white text-[18px] text-right mt-2">
          {{ t("Activities.Redpackage.MaxRemaining") }} R$
          <span class="text-[#FFDF12] text-[24px] mx-1">
            {{ formatter().format(configInfo.perEnvelopeShowMaxAmount || 0) }}
          </span>
        </div>
        <div class="flex-center flex-col">
          <div class="bgc1 w-[98%] h-[8px] mt-6"></div>
          <div class="w-[90%] h-[114px] bgc2 px-[10px] mt-[-4px]">
            <div class="text-[#151A1F] text-[13px] font-[600] text-center pt-[6px]">
              {{ t("Activities.Redpackage.OpeningHours") }}
            </div>
            <div class="w-full mt-3 ml-2">
              <template v-if="timeRange?.length">
                <div
                  ref="timeRangeRef"
                  class="h-[85px] overflow-y-auto flex flex-wrap items-center gap-x-2 gap-y-2.5 justify-start pb-[10px]"
                >
                  <div
                    v-for="({ start, end, isTime }, i) in timeRange"
                    :key="i"
                    class="flex justify-center items-center mb-[5px] w-[30%]"
                  >
                    <img :src="isTime ? red : black" class="w-[12px] h-[12px] mr-1" />
                    <span :class="['text-[#2F1780]', { 'text-[#FF3B30]': isTime }]">
                      {{ start }}-{{ end }}
                    </span>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="w-[90%] h-[20px] bgc4 mt-[-8px]"></div>
        </div>
        <Table v-if="configInfo.scope" :configInfo="configInfo" />
      </div>
      <ActivityDesc
        class="mt-4 px-4"
        :title="t('Activities.Redpackage.ActivityDescription')"
        :list="configInfo.activityConfigDesc"
      />
      <div class="fixed bottom-0 left-0 right-0 pt-2 pb-4 px-[16px] bg-[#151A1F]">
        <div class="py-4" v-if="showError">
          <div class="flex">
            <img src="./images/red_icon.png" class="w-[24px] h-[24px]" />
            <div class="ml-2 text-[15px] text-[#FF3B30]">
              {{ t("Activities.Redpackage.FailedToRedeem") }}
            </div>
          </div>
          <span class="text-[12px] block mt-2">
            {{ showError }}
          </span>
        </div>
        <van-button
          class="w-full rounded-lg"
          :class="{
            '!bg-[#7EF55F] font-bold': isOpenRedRainType === 1,
            '!bg-[#161A1F] !text-white': isOpenRedRainType !== 1,
          }"
          @click="isOpenRedRainType === 1 && getRedEnvelope()"
        >
          {{
            isOpenRedRainType === -1
              ? `Fechado ${String(days * 24 + hours).padStart(2, "0")}:${String(
                  minutes
                ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}  ${t(
                  "Activities.Redpackage.OpeningSoon"
                )}`
              : t("Activities.Redpackage.Mined")
          }}
        </van-button>
      </div>
    </div>

    <van-popup v-model:show="isOpenConfirm" :lock-scroll="false">
      <div class="pakage-content-success w-[284px] h-2/5 rounded-xl">
        <div class="relative flex justify-center items-center flex-col text-[#151A1F]">
          <div class="text-center mt-2 w-1/2 font-bold text-[15px]">
            {{ t("Activities.Redpackage.TodaysEarnings") }}
          </div>
          <img :src="red_money" class="w-15 h-15 mt-6" />
          <h1 class="font-bold text-4xl text-[#FF3B30]">
            {{ formatter().format(recievedData || 0) }}
            <span class="text-[13px] text-[#151A1F] font-[600]">R$</span>
          </h1>
          <span class="mt-4 text-[#151A1F] text-[12px]">{{
            t("Activities.Redpackage.CollectionTime")
          }}</span>
          <span class="mt-3 font-[600] text-[13px]">
            {{ dayjs().local().format("YYYY-MM-DD HH:mm:ss") }}
          </span>
        </div>
        <div
          @click="
            () => {
              isOpenConfirm = false;
              getConfigDetail();
            }
          "
          class="text-[15px] text-[#151A1F] font-[600] absolute bottom-[30px] left-0 w-full text-center"
        >
          {{ t("Common.Confirm") }}
        </div>
      </div>
    </van-popup>
  </withTopNav>
</template>

<script setup lang="tsx">
import withTopNav from "@/layouts/withTopNav.vue";
import ActivityDesc from "@/components/ActivityDesc/index.vue";
import Table from "./compontents/Table.vue";
import topBg from "./images/topBg.png";
import { formatter } from "@/utils";
import { configDetail, configDetailWithoutAuth } from "@/api/redpackage";
import { ref } from "vue";
import { receber } from "@/hooks/useActivity";
import dayjs from "dayjs";
import debounce from "lodash-es/debounce";
import black from "./images/black.png";
import red from "./images/red.png";
import red_money from "./images/red_money.png";
import { useUserInfo } from "@/store";
import { useRoute } from "vue-router";
import useTimeCountDown from "@/hooks/useTimeCountDown";
import { useSystemInfo } from "@/store";
import { useI18n } from "vue-i18n";
const activityId: any = useRoute().query.activityId || "";
const isOpenRedRainType = ref(1);
const configInfo = ref<any>({});
const recievedData = ref<any>(0);
const isOpenConfirm = ref(false);
const timeRangeRef = ref<any>(null);
const showError = ref("");
const timer = ref<any>(null);
const { t } = useI18n();

// 查询活动配置
const getConfigDetail = async () => {
  const fn = useUserInfo().isLoggedin ? configDetail : configDetailWithoutAuth;
  const { code, data } = await fn({
    activityId,
    language: useSystemInfo().language,
  });
  if (code === 1) {
    const timeRangeList = data?.timeRangeList ? data?.timeRangeList : [];

    const activityConfigDesc = data?.activityConfigDesc?.split("\n") || [];

    configInfo.value = { ...data, timeRangeList, activityConfigDesc };
  }
};

// 时间范围转换
const timeRange = computed(() => {
  const timeList = configInfo.value?.timeRangeList || [];
  let list: any = [];
  if (timeList.length) {
    list = timeList
      .sort((a, b) => {
        const format = "HH:mm";
        const startA = dayjs(a.startString, format);
        const startB = dayjs(b.startString, format);
        // 比较两个时间
        return startA.isBefore(startB) ? -1 : 1;
      })
      .map((item) => {
        const startTime = convertUTCToLocalTime(item.startString);
        const endTime = convertUTCToLocalTime(item.endString);
        const isTime = isCurrentTimeInRange(startTime, endTime);
        return {
          start: startTime,
          end: endTime,
          isTime,
        };
      });
  }
  // 滚动到当前时间
  const currentIndex = list.findIndex((item) => item.isTime);
  if (currentIndex !== -1) {
    const rowIndex = Math.floor(currentIndex / 3);
    const scrollPosition = rowIndex * 31;
    if (timeRangeRef.value) {
      timeRangeRef.value.scrollTop = scrollPosition;
    }
  }

  //当前时间在范围内并且未领取红包 判断是否可以领取红包
  if (configInfo.value.received) {
    isOpenRedRainType.value = -1;
  } else {
    isOpenRedRainType.value = 1;
  }

  return list;
});

// //验证是否可以领取红包
const verifyCanReceiveRed = () => {
  const {
    scope,
    betAmount,
    requireBet,
    depositAmount,
    requireDeposit,
  } = configInfo.value;
  const isBetSufficient = Number(betAmount) >= Number(requireBet);
  const isDepositSufficient = Number(depositAmount) >= Number(requireDeposit);
  let canSend = false;
  switch (scope) {
    case "Any":
      if (isBetSufficient || isDepositSufficient) {
        canSend = true;
      }
      break;
    case "All":
      if (isBetSufficient && isDepositSufficient) {
        canSend = true;
      }
      break;
    case "HasDeposit":
      if (Number(depositAmount) > 0) {
        canSend = true;
      }
      break;
    case "Unlimited":
      canSend = true;
      break;
  }

  if (!canSend) {
    showError.value = t("Activities.Redpackage.NotEigible");
  }
  return canSend;
};

// 领取红包
const getRedEnvelope = debounce(async () => {
  const canSend = verifyCanReceiveRed();
  if (!canSend) return;
  try {
    const data = await receber({
      flowType: "RedEnvelopeRainReward",
      activityId: activityId,
    });
    recievedData.value = data || 0;
    isOpenRedRainType.value = -1;
    isOpenConfirm.value = true;
    closeToast();
  } catch (error: any) {
    if (error.code === -5018) {
      showError.value = t("Activities.Redpackage.SorryLimitReached");
    } else {
      showError.value = t("Activities.Redpackage.NotEigible");
    }

    console.log(error);
  }
}, 800);

// 判断当前时间是否在范围内
const isCurrentTimeInRange = (start, end) => {
  const format = "HH:mm";
  const now = dayjs();
  const startTime = dayjs(start, format);
  const endTime = dayjs(end, format);

  if (endTime.isBefore(startTime)) {
    return now.isAfter(startTime) || now.isBefore(endTime);
  } else {
    return now.isAfter(startTime) && now.isBefore(endTime);
  }
};
// 将utc时间d段转为当前本地时间
const convertUTCToLocalTime = (timeString: any) => {
  // 获取当前日期
  const todayDate = dayjs().format("YYYY-MM-DD");
  // 将日期和时间组合在一起，并将其视为 UTC-3 时间
  const timeInUTC = dayjs.tz(
    `${todayDate} ${timeString}`,
    "YYYY-MM-DD HH:mm",
    "America/Sao_Paulo"
  );
  // 转换为本地时间
  const timeInLocal = timeInUTC.local();
  // 返回本地时间的小时和分钟
  return timeInLocal.format("HH:mm");
};

const timeToCountDown = computed(() => {
  return configInfo.value.nextPeriodTime - Date.now();
});
const { days, hours, minutes, seconds, changeTime } = useTimeCountDown(
  timeToCountDown.value,
  getConfigDetail
);

watch(
  timeToCountDown,
  (newVal) => {
    if (newVal > 1000) changeTime(newVal);
  },
  { once: true }
);

watch(showError, (newVal) => {
  if (newVal) {
    timer.value = setTimeout(() => {
      showError.value = "";
    }, 3000);
  }
});

onBeforeUnmount(() => {
  if (timer.value) {
    clearTimeout(timer.value);
  }
});

onMounted(() => {
  getConfigDetail();
});
</script>

<style lang="scss" scoped>
.bgc1 {
  background-image: url(./images/bg1.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.bgc2 {
  background-image: url(./images/bg2.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.bgc4 {
  background-image: url(./images/bg4.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.pakage-content-success {
  background-image: url(./images/bg3.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 326px;
}
</style>
